import { useEffect } from 'react';
import { Link, Outlet, ScrollRestoration, useLocation } from 'react-router';
import { useSite } from '@/features/site/SiteProvider';
import { SiteFooter } from './SiteFooter';
import { SiteHeader } from './SiteHeader';

export { NAV_ITEMS } from './SiteHeader';

function PreviewBanner() {
  const { preview } = useSite();
  if (!preview) return null;
  return (
    <div role="status" className="bg-amber-300 px-4 py-2 text-center text-[13px] font-semibold text-amber-950">
      Preview mode — you are viewing unpublished drafts. Visitors see the published version.{' '}
      <Link to="/admin/content" className="underline">
        Back to content editor
      </Link>
    </div>
  );
}

/** Scrolls to `#hash` targets after client-side navigation. */
function HashScroller() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    const t = window.setTimeout(() => document.getElementById(id)?.scrollIntoView({ block: 'start' }), 50);
    return () => window.clearTimeout(t);
  }, [hash, pathname]);
  return null;
}

export function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <a href="#main" className="sr-only z-[100] rounded-[6px] bg-white px-4 py-2 font-semibold focus:not-sr-only focus:fixed focus:top-2 focus:left-2">
        Skip to content
      </a>
      <PreviewBanner />
      <SiteHeader />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <ScrollRestoration />
      <HashScroller />
    </div>
  );
}
